import { createListCollection, Select } from '@chakra-ui/react';
import { BannerPlatform } from '@client/graphql/types/graphql';
import { useFocusedCompany } from '@packages/core/company/focused-company-context';
import { CompanyCategory } from '@packages/network-graphql/graphql/types/graphql';
import { useTranslate } from '@tolgee/react';
import { capitalize } from 'lodash';

const restaurantBannerPlatformList: BannerPlatform[] = [
  BannerPlatform.OnlineOrder,
  BannerPlatform.DigitalMenu,
  BannerPlatform.TableReservation,
  BannerPlatform.Hubpage,
];

const appointnmentBannerPlatformList: BannerPlatform[] = [BannerPlatform.NailAppointment, BannerPlatform.Hubpage];

export default function BannerPlatformSelection(props: {
  platform: BannerPlatform[];
  onChange: (value: BannerPlatform[]) => void;
}) {
  const { t } = useTranslate();
  const company = useFocusedCompany();

  const restaurantPlatformData = createListCollection({
    items: [
      ...restaurantBannerPlatformList.map((platform) => ({
        label: t(`banner-platform.${platform}`, capitalize(platform)),
        value: platform,
      })),
    ],
  });

  const appointmentPlatformData = createListCollection({
    items: [
      ...appointnmentBannerPlatformList.map((platform) => ({
        label: t(`banner-platform.${platform}`, capitalize(platform)),
        value: platform,
      })),
    ],
  });

  const companyTypeMatchingList = company.category.includes(CompanyCategory.Service)
    ? appointmentPlatformData
    : restaurantPlatformData;

  return (
    <>
      <Select.Root
        multiple
        defaultValue={props.platform}
        onValueChange={({ value }) => {
          props.onChange(value as BannerPlatform[]);
        }}
        border={'solid 1px'}
        borderColor={'gray.300'}
        rounded={'sm'}
        p={1}
        collection={restaurantPlatformData}
        size="sm"
      >
        <Select.HiddenSelect />
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText px={2} placeholder={t('banne.platform.placeholder', 'Select platforms')} />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            {companyTypeMatchingList.items.map((framework) => (
              <Select.Item zIndex={50} item={framework} key={framework.value}>
                {framework.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </>
  );
}
